import { Box, Text } from '@chakra-ui/react'

import * as React from 'react'
import { useState } from 'react'
// import { AssessmentInterfaceContext } from '../../contexts/AssessmentContext'

import { useProfile } from '../../../contexts'
import { BlueButton } from '../../Buttons/BlueButton'
import { Expandable } from '../../Expandable'
import { AssessmentLog } from '../../Users/Profile/Log/AssessmentLog'
import { AssessmentQuestionnaireView } from './QuestionnaireView'

export const AssessmentAnswers: React.FC<{
  assessmentId: string
  onSubmit?: () => Promise<any>
  width: number
}> = ({ onSubmit, assessmentId, width }) => {
  const {
    selectedAssessment: { populated: assessment },
  } = useProfile()

  const [submitting, setSubmitting] = useState(false)

  return (
    <Box w="100%" px={2} pb={2}>
      <AssessmentQuestionnaireView assessmentId={assessmentId} />
      {!assessment?.submittedOn && onSubmit ? (
        <BlueButton
          mt={4}
          size="sm"
          isLoading={submitting}
          onClick={async () => {
            setSubmitting(true)
            try {
              await onSubmit()
            } catch (err) {
              console.error(err)
            }
            setSubmitting(false)
          }}>
          Submit Questionnaire
        </BlueButton>
      ) : null}
      <Expandable
        mt={3}
        width={`${width - 40}px`}
        borderRadius={4}
        bg="gray.50"
        headerProps={{ bg: 'white', borderRadius: 4 }}
        border="1px solid #cdcdcd"
        header={() => (
          <Text fontWeight={600} py={1} fontSize="lg" px={2} color="gray.600">
            Log
          </Text>
        )}>
        <Box overflowX="hidden" bg="gray.100" w="100%" height="600px">
          <AssessmentLog maxHeight={600} />
        </Box>
      </Expandable>
    </Box>
  )
}
